import { motion } from "framer-motion";
import { Instagram, Facebook, ArrowUpRight } from "lucide-react";
import { BRAND } from "@/brand";

const EASE = [0.22, 1, 0.36, 1];

const CARDS = [
    {
        icon: Instagram,
        name: "Instagram",
        handle: BRAND.instagramHandle,
        url: BRAND.instagram,
        text: "Behind the batches — test cooks, farmers' market runs and first-jar reveals.",
        testid: "social-link-instagram",
    },
    {
        icon: Facebook,
        name: "Facebook",
        handle: "SpiceJam Kitchen",
        url: BRAND.facebook,
        text: "Launch news, market dates across Ontario and where to taste first.",
        testid: "social-link-facebook",
    },
];

export const Social = () => (
    <section className="mx-auto max-w-7xl px-5 py-28 sm:px-8 sm:py-32" data-testid="social-section">
        <motion.div
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, ease: EASE }}
        >
            <p className="text-xs font-semibold uppercase tracking-[0.3em] text-bonnetglow">Follow the fire</p>
            <h2 className="mt-4 max-w-xl font-display text-4xl font-extrabold uppercase leading-[0.95] tracking-tight text-parchment sm:text-5xl">
                Watch the kitchen <span className="font-editorial font-medium normal-case italic text-nutmeg">come alive</span>
            </h2>
        </motion.div>

        <div className="mt-14 grid gap-8 sm:grid-cols-2">
            {CARDS.map((c, i) => (
                <motion.a
                    key={c.name}
                    href={c.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8, ease: EASE, delay: i * 0.12 }}
                    className="group flex items-start justify-between gap-6 rounded-3xl border border-white/10 bg-soot p-8 transition-[border-color,box-shadow,transform] duration-500 hover:-translate-y-1.5 hover:border-nutmeg/40 hover:shadow-[0_32px_64px_-32px_rgba(234,179,8,0.25)] sm:p-10"
                    data-testid={c.testid}
                >
                    <div>
                        <span className="flex h-12 w-12 items-center justify-center rounded-2xl border border-nutmeg/30 bg-nutmeg/10 transition-colors duration-300 group-hover:bg-nutmeg/20">
                            <c.icon className="h-5 w-5 text-nutmeg" />
                        </span>
                        <h3 className="mt-6 font-display text-2xl font-extrabold uppercase tracking-tight text-parchment">
                            {c.name}
                        </h3>
                        <p className="mt-1 text-sm font-semibold text-nutmeg">{c.handle}</p>
                        <p className="mt-4 text-sm leading-relaxed text-sand">{c.text}</p>
                    </div>
                    <ArrowUpRight className="h-6 w-6 shrink-0 text-sand/40 transition-[color,transform] duration-300 group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-nutmeg" />
                </motion.a>
            ))}
        </div>
    </section>
);

export default Social;
